import { useQuery } from '@tanstack/react-query';

import { DataLakeQuery } from '@graylog/enterprise-api';

import type { ActivePreviewSearch } from 'data-lake/preview/Types';
import { INITIAL_PAGE, PAGE_SIZE, DATA_LAKE_PREVIEW_QUERY_KEY } from 'data-lake/preview/Constants';

// @ts-expect-error Types do not overlap due to polymorphy
const fetchActiveSearch = (): Promise<ActivePreviewSearch> => DataLakeQuery.activeQuery(INITIAL_PAGE, PAGE_SIZE);

const useFetchActiveSearch = (
  enabled = true,
): {
  data: ActivePreviewSearch | undefined;
  isLoading?: boolean;
  refetch: () => Promise<unknown>;
} =>
  useQuery({
    queryKey: [DATA_LAKE_PREVIEW_QUERY_KEY, 'active-query'],
    queryFn: fetchActiveSearch,
    retry: 0,
    enabled,
  });

export default useFetchActiveSearch;
